var map = {
	"./ic_avax_40.svg": 531,
	"./ic_bnb_40.svg": 532,
	"./ic_btc_40.svg": 378,
	"./ic_eth_40.svg": 379,
	"./ic_frax_40.svg": 533,
	"./ic_glp_40.svg": 535,
	"./ic_link_40.svg": 536,
	"./ic_mim_40.svg": 537,
	"./ic_uni_40.svg": 538,
	"./ic_usdc.e_40.svg": 539,
	"./ic_usdc_40.svg": 540,
	"./ic_usdt_40.svg": 541,
	"./ic_wavax_40.svg": 542,
	"./ic_wbnb_40.svg": 543,
	"./ic_weth_40.svg": 544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 936;